export enum SessionCardStatus {
  NOW = 'now',
  NEXT = 'next',
}
